/**
 * Account schemas — patient billing accounts.
 *
 * Enum arrays are tied to fhir-model types via `satisfies`.
 */
import { z } from 'zod';
import type { AccountStatus as FhirAccountStatus } from '@unify/fhir-model/resources/account';

/** FHIR Account.status values — synced with fhir-model. */
export const accountStatusValues = [
  'active',
  'inactive',
] as const satisfies readonly FhirAccountStatus[];

/**
 * Create / update a patient billing account.
 */
export const accountSchema = z.object({
  patientId: z.string().min(1, 'Patient is required'),
  name: z.string().trim().min(1, 'Account name is required'),
  status: z.enum(accountStatusValues).default('active'),
  guarantorPatientId: z.string().optional(),
});

export type AccountInput = z.infer<typeof accountSchema>;
